export default __webpack_public_path__ + "ec52896997e433a6f7e6f7de90255aa0.png";